import { createSlice } from '@reduxjs/toolkit';
import { DashboardState } from '../types/dashboard';

const initialState: DashboardState = {
    registered_company_num: 5,
    waiting_confirm_num: 12,
    confirmed_num: 8,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
  },
});

export default dashboardSlice.reducer;